import React from 'react';
import classNames from 'classnames';
import i18next from 'i18next';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';
import { getPathFromAlternativePaths } from '../../../../helpers';

import './style.scss';

const OpinionTeaserLarge = ({ entity, className, direction }) => {
  const classes = classNames(className, [
    'OpinionTeaserLarge',
    direction === 'right' ? 'reversed' : null,
  ]);
  const url = getPathFromAlternativePaths(entity, ['opinion', 'opinie']);

  return (
    <article typeof="schema:WebPage" className={classes}>
      <CoreLink to={url} className="overlapping-link" />
      <div className="OpinionTeaserLarge__content">
        <div className="OpinionTeaserLarge__imageWrapper">
          <Image
            alt={entity.getIn(['field_teaser_media', 0, 'title'], '')}
            lazyload={false}
            src={entity.getIn(['field_teaser_media', 0, 'styles', 'teaser_square'], '')}
          />
        </div>
        <div className="OpinionTeaserLarge__contentWrapper">
          <div className="node--sub-heading">
            <div className="node--sub-heading node--sub-heading--with-labels">
              {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value']) ? (
                <div className="theme-labels">
                  <div className="theme-label">
                    {entity.getIn(['field_theme', 0, 'entity', 'name', 0, 'value'], '')}
                  </div>
                  {entity.getIn(['field_theme']).size > 1 && (
                    <div className="theme-label">
                      +{entity.getIn(['field_theme']).size - 1}
                    </div>
                  )}
                </div>
              ) : null}
              <span>{i18next.t('opinion')}</span>
            </div>
          </div>
          <h2>{entity.getIn(['title', 0, 'value'])}</h2>
          <div className="node--sub-heading-quote">
            — {entity.getIn(['field_author', 0, 'value'], '')}
          </div>
        </div>
      </div>
    </article>
  );
};

export default OpinionTeaserLarge;
